import React from 'react'
import Home from '../components/home.component'
import WhyComponent from '../components/why.component'
import AboutComponent from '../components/about.component'
import BookComponent from '../components/book.component'
import FooterComponent from '../components/footer.component'
import SloganComponent from '../components/slogan.component'
import HorizontalComponent from '../components/horizontal.component'
import OurWorkComponent from '../components/ourwork.component'
import ReviewsComponent from '../components/reviews.component'
import useSEO from '../hooks/useSEO'

function LandingPage() {
    useSEO({
        title: 'Mehandi Malabar | Best Bridal Mehandi Artist in Malappuram, Kerala',
        description: 'Mehandi Malabar – professional mehandi artist in Kondotty, Malappuram. Bridal, Arabic, Traditional & Indian henna designs for weddings, Eid and all occasions across Kerala.',
        path: '/',
    });

    return (
        <div>
            <Home />
            <AboutComponent />
            <OurWorkComponent />
            <BookComponent />
            <SloganComponent />
            <HorizontalComponent />
            <ReviewsComponent />
            <WhyComponent />
            <FooterComponent />
        </div>
    )
}

export default LandingPage
